var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8287 2.25729C7.72897 3.55965 4.67935 5.37014 2.51198 7.68874C2.0855 8.14498 2.42834 8.84828 3.05287 8.84828H19.7263C20.3508 8.84828 20.6937 8.14498 20.2672 7.68874C18.0998 5.37014 15.0502 3.55965 11.9504 2.25729C11.5916 2.10652 11.1876 2.10652 10.8287 2.25729Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 2.27365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32645 16.4277C3.56444 16.4277 2.71276 17.7932 2.41869 19.466C2.27374 20.2905 2.97355 20.975 3.81069 20.975H18.9683C19.8055 20.975 20.5053 20.2905 20.3603 19.466C20.0663 17.7932 19.2146 16.4277 17.4526 16.4277H5.32645Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 2.27365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32617 16.4265V8.84766",
    stroke: "#84C70D",
    strokeWidth: 2.27365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3906 16.4265V8.84766",
    stroke: "#84C70D",
    strokeWidth: 2.27365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4531 16.4265V8.84766",
    stroke: "#84C70D",
    strokeWidth: 2.27365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.ce796c0615e8ba7f580232030d7619b9.svg";
export { ForwardRef as ReactComponent };